import { version } from '../package.json';

type AppConfiguration = {
  version: string;
};

export const appConfiguration = (): AppConfiguration => ({
  version,
});

export default appConfiguration;
